import styled from 'styled-components';
import { Title4 } from '../../Typography';

export const SubTitleStyled = styled(Title4)`
  padding-top: 0px;
`;
